import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        tasklist: '=',
        tasklistTemplates: '=',
        classifiers: '=',
        isAdd: '='
    },
    template: `
        <div class="heading01 type01">
            <h1 ng-if="vm.isAdd">{{ 'tasklist.Assign tasklist' | translate }}</h1>
            <h1 ng-if="!vm.isAdd">{{ vm.form.model.user.displayName }}</h1>
            <ul class="actions01">
                <li><a class="btn discrete" ui-sref="authorized.user.tasklist.list()">{{ 'tasklist.Back to listing' | translate }}</a></li>
            </ul>
        </div>
        <div class="well type02 mt2em">
            <form class="form">
                <form-row error="vm.form.errors.userId">
                    <span class="label">{{ 'tasklist.Assigned to' | translate }}</span>
                    <div class="items">
                        <a ng-if="!vm.form.model.userId && vm.isAdd" class="btn add" ng-click="vm.chooseEmployee()"
                        >{{ 'tasklist.Choose employee' | translate }}</a>
                        <a ng-if="vm.form.model.userId && vm.isAdd" ng-click="vm.chooseEmployee()">
                            <span class="text">{{ vm.selectedUser.displayName }}</span>
                        </a>
                        <span ng-if="!vm.isAdd" class="text">{{ vm.selectedUser.displayName }}</span>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.tasklistTemplateId">
                    <label class="label">{{ 'tasklist.Tasklist template' | translate }}</label>
                    <div class="items">
                        <form-row-error></form-row-error>
                            <select ng-if="vm.isAdd"
                                    class="form-control"
                                    ng-model="vm.form.model.tasklistTemplateId"
                                    ng-change="vm.changeTemplate()"
                                    ng-options="template.id as template.name for template in vm.tasklistTemplates track by template.id">
                            </select>
                        <span ng-if="!vm.isAdd" class="text">{{ vm.selectedTemplate.name }}</span>
                    </div>
                </form-row>
                <div ng-if="vm.form.model.tasklistTasks">
                    <h2>{{ 'tasklist.Tasks' | translate }}</h2>
                    <ul class="items06">
                        <li ng-repeat="task in vm.form.model.tasklistTasks">
                            <div class="form">
                                <form-row error="vm.form.errors.tasklistTasks[$index].name">
                                    <span class="label">{{ 'tasklist.Task name' | translate }}</span>
                                    <div class="items"><span class="text">{{ task.name }}</span></div>
                                </form-row>
                                <form-row error="vm.form.errors.tasklistTasks[$index].description" additional-classes="'row-html'">
                                    <span class="label">{{ 'tasklist.Description' | translate }}</span>
                                    <div class="items" ng-bind-html="task.description" ng-if="task.description"></div>
                                    <div class="items" ng-if="!task.description"><span class="text">-</span></div>
                                </form-row>
                                <form-row error="vm.form.errors.tasklistTasks[$index].deadline">
                                    <span class="label">{{ 'tasklist.Deadline' | translate }}</span>
                                    <div class="items">
                                        <datepicker-api ng-model="vm.form.model.tasklistTasks[$index].deadline"
                                            ng-change="vm.setSameDeadlinesToAllTasks()"/>
                                        <ul class="checkboxes c-both" ng-if="$index == 0">
                                            <li>
                                                <label>
                                                    <input type="checkbox"
                                                        ng-model="vm.isSameDeadline"
                                                        ng-change="vm.setSameDeadlinesToAllTasks()" />
                                                    <span>{{ 'tasklist.Apply same to all' | translate }}</span>
                                                </label>
                                            </li>
                                        </ul>
                                        <form-row-error></form-row-error>
                                    </div>
                                </form-row>
                                <form-row error="vm.form.errors.tasklistTasks[$index].comment">
                                    <span class="label">{{ 'tasklist.Comment' | translate }}</span>
                                    <div class="items">
                                        <textarea class="form-control" ng-model="vm.form.model.tasklistTasks[$index].comment"></textarea>
                                    </div>
                                </form-row>
                                <form-row ng-if="task.fileId" error="vm.form.errors.tasklistTasks[$index].attachment">
                                    <span class="label">{{ 'tasklist.Attachment' | translate }}</span>
                                    <div class="items"><span class="text"><a ng-click="vm.downloadFile(task.fileId)">{{ task.file.filename }}</a></span></div>
                                </form-row>
                                <form-row error="vm.form.errors.tasklistTasks[$index].status">
                                    <span class="label">{{ 'tasklist.Completed' | translate }}</span>
                                    <div class="items">
                                        <label class="switch01">
                                            <input type="checkbox" name="switch" ng-checked="vm.isCompleteStatus(task)" ng-click="vm.toggleStatus(task)">
                                                <span>{{ 'general.Yes' | translate }}</span>
                                        </label>
                                        <p ng-if="task.completedBy" class="desc">{{ vm.getCompletorLabel(task) }}</p>
                                    </div>
                                </form-row>
                            </div>
                        </li>
                    </ul>
                </div>
            </form>
        </div>
        <ul class="actions01">
            <li class="primary">
                <a ng-click="vm.save()" class="btn main">{{ 'general.Save' | translate }}</a>
            </li>
            <li>
                <a ui-sref="authorized.user.tasklist.list()" class="btn discrete">{{ 'general.Cancel' | translate }}</a>
            </li>
        </ul>
    `
})
export default class {
    constructor ($timeout, $translate, $state, toastr, lodash, FormFactory, MomentService, ModalService, SiteService, TasklistTemplateResource,
                 TASKLIST_TASK_STATUS_ENUM, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM, $window, AuthResource) {
        this.$state = $state;
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.isSameDeadline = false;
        this.FormFactory = FormFactory;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.SiteService = SiteService;
        this.TasklistTemplateResource = TasklistTemplateResource;
        this.TASKLIST_TASK_STATUS_ENUM = TASKLIST_TASK_STATUS_ENUM;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.timeout = $timeout;
        this.$window = $window;
        this.AuthResource = AuthResource;
    }

    $onInit () {
        if (!this.isAdd) {
            this.selectedUser = this.tasklist.user;
            this.selectedTemplate = this.tasklist.tasklistTemplate;
        }

        this.tasklist = this.sortTasklist(this.tasklist);

        this.form = this.FormFactory.createFromResource(this.tasklist);
        this.sites = this.SiteService.getSitesByPrivileges([this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.TASKLIST_MANAGE]);
    }


    sortTasklist (tasklist) {
        if (tasklist.tasklistTasks) {
            const nextTask = tasklist.tasklistTasks.filter(task => task.id === tasklist.nextTaskId);
            const tasksWithoutNextTask = tasklist.tasklistTasks.filter(task => task.id !== tasklist.nextTaskId);

            tasklist.tasklistTasks = [...nextTask, ...tasksWithoutNextTask];
        }
        return tasklist;
    }

    downloadFile (id) {
        this.AuthResource
        .requestTacToken().$promise
        .then(({ token }) => {
            const url = `${SEED_CORE.ENV.API_URL}tasklist/template/task-attachment-export?tacToken=${token}&id=${id}`;
            this.$window.open(url);
        });
    }


    isCompleteStatus (task) {
        return task.status === this.TASKLIST_TASK_STATUS_ENUM.KEYS.COMPLETED;
    }

    getCompletorLabel (task) {
        const completor = task.completor.displayName;
        const completedAt = task.completedAt + 3 * 60 * 60;
        const date = this.MomentService.formatTimeStamp(completedAt, 'DD.MM.YYYY HH:mm', true);
        return this.$translate.instant('tasklist.Completed at {date} by: {completor}', {
            date, completor
        });
    }

    toggleStatus (task) {
        if (this.isCompleteStatus(task)) {
            task.status = this.TASKLIST_TASK_STATUS_ENUM.KEYS.INCOMPLETE;
        }
        else {
            task.status = this.TASKLIST_TASK_STATUS_ENUM.KEYS.COMPLETED;
        }
    }

    save () {
        this.form.save({ expand: 'tasklistTasks.file,tasklistTemplate,user,tasklistTasks.completor' }).then(tasklist => {
            this.toastr.success(this.$translate.instant('general.Changes saved'));
            if (this.isAdd) {
                this.$state.go('authorized.user.tasklist.edit', { id: tasklist.id });
            }

            tasklist = this.sortTasklist(tasklist);
        });
    }

    /** Starting here is add view functionality only */
    chooseEmployee () {
        const { classifiers, sites } = this;
        this.ModalService
            .open({
                template: `
                    <modals-user-tasklist-employee
                        uib-modal-instance="vm.$uibModalInstance"
                        classifiers="vm.classifiers"
                        sites="vm.sites"
                    />
                `,
                controller ($uibModalInstance) {
                    this.$uibModalInstance = $uibModalInstance;
                    this.classifiers = classifiers;
                    this.sites = sites;
                },
                size: 'xlarge'
            })
            .then(user => {
                this.selectedUser = user;
                this.form.model.userId = user.id;
            })
        ;
    }

    setSameDeadlinesToAllTasks () {
        if (!this.isSameDeadline) {
            return;
        }
        this.timeout(() => {
            const deadline = this.form.model.tasklistTasks[0].deadline;
            this.form.model.tasklistTasks.forEach((task) => {
                task.deadline = deadline;
            });
        });
    }

    changeTemplate () {
        this.selectedTemplate = this.lodash.find(
            this.tasklistTemplates,
            { id: parseInt(this.form.model.tasklistTemplateId, 10) }
        );

        this.form.model.tasklistTasks = this.selectedTemplate.templateTasks.map(templateTask => {
            return {
                name: templateTask.name,
                templateTaskId: templateTask.id,
                fileId: templateTask.fileId,
                file: templateTask.fileId ? templateTask.file : null,
                description: templateTask.description,
                status: this.TASKLIST_TASK_STATUS_ENUM.KEYS.INCOMPLETE
            };
        });

        this.form.model = this.sortTasklist(this.form.model);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/tasklist/form/index.js